import vela from "../../assets/images/services/vela.jpeg";
import bioenergetica from "../../assets/images/services/bioenergetica2.jpg";
import tradicional from "../../assets/images/services/tradicional.jpeg";
import reiki from "../../assets/images/services/reiki.jpg";
import drenagem from "../../assets/images/services/drenagem.jpeg";
import meditacao from "../../assets/images/services/meditacao.jpg";
import miofascial from "../../assets/images/services/miofascial.jpg";

const servicesData = [
  {
    title: "Massagem Relaxante Tradicional",
    sectionLink: "relaxante",
    whatIsIt: "Técnica manual com movimentos suaves e lentos, promovendo relaxamento físico e mental.",
    whatSolves: [
      "Estresse e fadiga acumulada",
      "Ansiedade leve e irritabilidade",
      "Insônia e dificuldade em relaxar",
      "Dores leves de tensão muscular"
    ],
    expectedResults: [
      "Relaxamento profundo e tranquilidade",
      "Redução de estresse e ansiedade",
      "Melhora do sono e do humor",
      "Renovação das energias físicas e emocionais"
    ],
    benefits: [
      "Redução do estresse e da ansiedade",
      "Alívio de dores musculares causadas por tensão e má postura",
      "Melhora da circulação sanguínea e oxigenação dos tecidos",
      "Sensação imediata de bem-estar e disposição",
    ],
    description:
      "Técnica de toque suave e contínuo, com movimentos rítmicos que promovem relaxamento físico e mental.",
    imageUrl: tradicional,
  },
  {
    title: "Drenagem Linfática Manual",
    sectionLink: "linfatica",
    whatIsIt: "Técnica manual com movimentos leves que estimulam o sistema linfático, favorecendo eliminação de líquidos e toxinas.",
    whatSolves: [
      "Retenção de líquidos e inchaço",
      "Sensação de peso e cansaço nas pernas",
      "Desconfortos circulatórios leves",
      "Celulite por acúmulo de líquidos"
    ],
    expectedResults: [
      "Sensação imediata de leveza",
      "Redução de inchaço e melhora da silhueta",
      "Melhora da circulação e oxigenação dos tecidos",
      "Relaxamento profundo e maior disposição"
    ],
    benefits: [
      "Diminuição de inchaços e sensação de peso nas pernas",
      "Estímulo ao sistema imunológico",
      "Melhora da circulação e da oxigenação celular",
      "Redução da sensação de cansaço e fadiga física",
    ],
    description:
      "Técnica que estimula o sistema linfático a eliminar toxinas e líquidos retidos, com toques leves e precisos.",
    imageUrl: drenagem,
  },
  {
    title: "Tratamento Bioenergético",
    sectionLink: "bioenergetica",
    whatIsIt: "Protocolo terapêutico integrativo que combina avaliação, conversa terapêutica, massagem bioenergética e Reiki.",
    whatSolves: [
      "Redução da ansiedade e estresse",
      "Alívio de sintomas depressivos",
      "Facilitação da expressão emocional",
      "Dores recorrentes ligadas à tensão emocional e sobrecarga física",
      "Dificuldade em relaxar e recuperar vitalidade",
      "Sensação de esgotamento persistente"
    ],
    expectedResults: [
      "Redução progressiva de dores e tensões",
      "Sensação de leveza física e emocional",
      "Melhora do sono, disposição e humor",
      "Clareza emocional e maior resiliência",
      "Transformações consistentes ao longo das sessões"
    ],
    benefits: [
      "Desbloqueio de tensões crônicas e emoções reprimidas",
      "Redução de estados de irritabilidade, apatia ou ansiedade",
      "Melhora da consciência corporal e da respiração",
      "Favorece o equilíbrio entre corpo, mente e emoções",
    ],
    description:
      "Protocolo terapêutico integrativo que combina avaliação, conversa terapêutica, massagem bioenergética e Reiki.",
    imageUrl: bioenergetica,
  },
  {
    title: "Liberação Miofascial",
    sectionLink: "miofascial",
    whatIsIt: "Técnica manual sobre a fáscia para liberar pontos de tensão e rigidez que geram dor e limitam movimentos.",
    whatSolves: [
      "Dores crônicas em costas, ombros, lombar e pescoço",
      "Tensão muscular por estresse ou má postura",
      "Limitação de movimento e rigidez corporal"
    ],
    expectedResults: [
      "Alívio imediato e duradouro da dor",
      "Melhora da mobilidade e postura",
      "Redução de tensões físicas acumuladas",
      "Sensação de leveza e liberdade corporal"
    ],
    benefits: [
      "Alívio de dores crônicas, tensões localizadas e rigidez muscular",
      "Aumento da mobilidade e flexibilidade corporal",
      "Melhora da postura e da performance física",
      "Prevenção de lesões por esforço repetitivo",
    ],
    description:
      "Terapia manual profunda que trabalha diretamente nos pontos de tensão da fáscia muscular (tecido que envolve os músculos).",
    imageUrl: miofascial,
  },
  {
    title: "Reiki",
    sectionLink: "reiki",
    whatIsIt: "Terapia energética japonesa baseada na imposição de mãos para equilibrar chakras e harmonizar corpo, mente e emoções.",
    whatSolves: [
      "Estresse, ansiedade e inquietação mental",
      "Insônia e fadiga emocional",
      "Tristeza, desânimo ou falta de clareza",
      "Desequilíbrios energéticos"
    ],
    expectedResults: [
      "Relaxamento profundo e calma mental",
      "Sono tranquilo e reparador",
      "Equilíbrio emocional e clareza interior",
      "Aumento da energia vital e sensação de paz"
    ],
    benefits: [
      "Alívio de estresse, ansiedade e esgotamento emocional",
      "Estímulo à autorregulação do organismo",
      "Clareza mental, leveza e sensação de paz interior",
      "Reforço da saúde emocional e bem-estar geral",
    ],
    description:
      "Técnica japonesa de imposição de mãos que promove equilíbrio energético e emocional, ideal para ambientes de alta demanda mental.",
    imageUrl: reiki,
  },
  {
    title: "Coneterapia",
    sectionLink: "coneterapia",
    whatIsIt: "Terapia ancestral com cones de algodão e cera de abelha, aplicados em pontos específicos, gerando calor e vibrações sutis.",
    whatSolves: [
      "Rinite, sinusite e congestão nasal",
      "Dores de cabeça e enxaquecas",
      "Zumbidos e vertigens",
      "Estresse mental, insônia e dificuldade de concentração",
      "Bloqueios energéticos que causam cansaço"
    ],
    expectedResults: [
      "Alívio de pressões e desconfortos na cabeça",
      "Respiração mais leve e clareza mental",
      "Relaxamento profundo e sono restaurador",
      "Redução do estresse e mais vitalidade"
    ],
    benefits: [
      "Alívio de tensões acumuladas e ruídos mentais",
      "Limpeza energética e sensação de leveza",
      "Auxilia na melhora da concentração e do sono",
      "Estimula estados de calma e presença",
    ],
    description:
      "Técnica ancestral que utiliza cones de cera vegetal em pontos energéticos como ouvidos e chacras, promovendo relaxamento profundo.",
    imageUrl: vela,
  },
  // {
  //   title: "Meditação Guiada",
  //   sectionLink: "meditacao-guiada",
  //   whatIsIt: "",
  //   whatSolves: "",
  //   expectedResults: "",
  //   benefits: [
  //     "Redução imediata do estresse e da ansiedade",
  //     "Aumento da concentração e clareza mental",
  //     "Melhoria do foco e produtividade no trabalho",
  //     "Estímulo à inteligência emocional e à autorregulação",
  //   ],
  //   description:
  //     "Prática conduzida com foco na respiração, atenção plena e relaxamento, utilizando visualizações, palavras e sons para induzir estados de calma e centramento.",
  //   imageUrl: meditacao,
  // }
];

export { servicesData };